/**
 * SpiffArena の識別子変換。
 *
 * process model id は `sales-forecast/budget-adjustment-approval` のように
 * スラッシュ区切りだが、API の path param では `:` 区切り
 * （modified_process_model_identifier）で渡す必要がある。
 * endpoints 層は必ずこの関数を経由し、replaceAll を直書きしない。
 */

/** process model id → path param 用の modified id。 */
export function toModifiedProcessModelId(processModelId: string): string {
  return processModelId.replaceAll("/", ":");
}

/** modified id → process model id。 */
export function fromModifiedProcessModelId(
  modifiedProcessModelId: string,
): string {
  return modifiedProcessModelId.replaceAll(":", "/");
}
